import React, { ComponentType } from 'react';
import PropTypes from 'prop-types';
import { error as errorEvent, ErrorPageType } from 'lib/trackingEvents';
import { ApiError } from 'lib/error';
import { usePageView } from './usePageView';

/**
 * @deprecated
 */
export const WithErrorPageViewPropType = {
  error: PropTypes.object.isRequired,
};

export const getErrorDetail = (error: ApiError) =>
  error.message ? error.message : '';

export const withErrorPageView =
  (errorType: ErrorPageType) =>
  <P,>(WrappedComponent: ComponentType<P>) =>
  (props: P & { error: ApiError }) => {
    const { error } = props;
    usePageView(
      errorEvent.getPageView(errorType, error.code, getErrorDetail(error)),
    );

    return <WrappedComponent {...props} />;
  };

export default withErrorPageView;
